import React, { useState } from 'react'
import AddNewNutritionHistory from './AddNewNutritionHistory';

const NutritionHistory = ({ data, setIsRecordSaved, patientID, ...props }) => {

  let { isViewAllowed,  IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenNutritionHistory, setIsOpenNutritionHistory] = useState(false);
  const [nutritionHistoryData, setNutritionHistoryData] = useState([]);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }


  const AddNutritionHistory = (item) => {
    if(!isViewAllowed) return;
    setNutritionHistoryData(item)
    setIsOpenNutritionHistory(prev => !prev);
  }
  const CloseNutritionHistory = () => {
    setIsOpenNutritionHistory(false)
  }

  let PopupScreen = "";
  if (isOpenNutritionHistory) {
    PopupScreen = <AddNewNutritionHistory isOpenNutritionHistory={isOpenNutritionHistory} nutritionHistoryData={nutritionHistoryData} setNutritionHistoryData={setNutritionHistoryData} setIsRecordSaved={setIsRecordSaved} onClose={CloseNutritionHistory} patientID={patientID} // onDeleteNutritionHistory={DeleteNutritionHistory} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <>
      {PopupScreen}
      <div className='mb-2'>
        <div className="d-flex justify-content-between align-items-center mb-1 mx-2">
          <p className='heading cursor-pointer user-select-none' onClick={handleToggleExpand}>Nutrition History</p>
          <div className={`ar-add-icon ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddNutritionHistory({ PatientHistoryID: null })}>
            <i className="icon-dash-plus"></i>
          </div>
        </div>
        <div className="d-flex flex-column gap-1 problem-scroll px-2">
          {expandItems &&
          (data?.length > 0 ?
            data.map(item => (
              <div className='ar-dot'>
                <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddNutritionHistory(item)}>{item.Notes}</p>
              </div>
            )) :
            <p className="text C9-light-clr fst-italic">No nutrition history recorded</p>)}
        </div>
      </div>
    </>
  )
}

export default NutritionHistory